// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2RQHn","actionsCol":"EnrolledClinics_actionsCol__Jrens"};